<script lang="ts">
    import type {ToastMessage} from 'shared/components/kp-toast-messages/types';
    import KpLoadingImg from 'shared/components/kp-loading/KpLoadingImg.svelte';
    import UIcon from 'shared/ui-widgets/uicons/UIcon.svelte';
    import ToastMessageCardContainer from 'shared/components/kp-toast-messages/ToastMessageCardContainer.svelte';

    export let toast: ToastMessage;
</script>

<ToastMessageCardContainer {toast} let:icon>
    <span class="icon-container">
        {#if toast.type === 'wait'}
            <KpLoadingImg size="xs" color="white"/>
        {:else}
            <UIcon icon="{icon ?? 'question'}"/>
        {/if}
    </span>

    <span class="texts-container">
        {#if toast.title}
            <span class="toast-title">{toast.title}</span>
        {/if}

        <span class="toast-message">{toast.message}</span>
    </span>
</ToastMessageCardContainer>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.media-queries.less";

    @media only screen and (max-width: @screen-xs-max) {
        .icon-container {
            font-size: @font-size-default;
        }

        .texts-container {
            font-size: @font-size-small;
        }
    }

    .icon-container {
        font-size: @font-size-large;
    }

    .texts-container {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: start;
        justify-content: start;
        text-align: start;
        word-break: break-word;

        .toast-title {
            font-weight: 500;
        }
    }
</style>